import React, { memo, useMemo } from "react";
import useAxiosQuery from "@/hooks/useMyQuery";
import MyCard from "@/app/components/MyCard";
import { useTranslations } from "next-intl";
import LinkToKlardaApp from "@/app/components/LinkToKlardaApp";
import Skeleton from "antd/lib/skeleton";
import MarketItem from "@/app/components/products/ProductMarket/MarketItem";

export interface IProductMarket {
  _id: string;
  changePercent: number;
  close: number;
  exchangeIcon: string;
  exchangeKey: string;
  exchangeName: string;
  from: string;
  symbol: string;
  to: string;
  url: string;
  description: string[];
}

const ProductMarket = ({ symbol }: { symbol: string }) => {
  const t = useTranslations("products");
  const { data: response, isLoading } = useAxiosQuery<{ data: { data: IProductMarket[] } }>({
    url: "/v1/product/market/market-public-by-symbol",
    params: { symbol },
  });

  const marketItems = useMemo(
    () => response?.data?.data?.map(item => <MarketItem key={item._id} item={item} />),
    [response?.data],
  );

  return (
    <MyCard styles={{ header: { textTransform: "uppercase" } }} title={t("market")}>
      {isLoading ? (
        <div className="w-full">
          <Skeleton paragraph={{ rows: 10 }} />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{marketItems}</div>
      )}
      <LinkToKlardaApp isOnlyText />
    </MyCard>
  );
};

export default memo(ProductMarket);
